$(function() {

    CustomEase.create("customEase", "0.19, 1, 0.22, 1");
    gsap.registerPlugin(Draggable);

    $(document).on("click", "[data-bottom-sheet]", function(e) {
        e.preventDefault();
        $('body').addClass('overflow-hidden');
        const sheetId = $(this).data("bottom-sheet");
        const $sheet = $(`[data-sheet-id="${sheetId}"]`);
        const $overlay = $("#overlay-bottom-sheet");

        $overlay.addClass("show");
        $sheet.addClass("show");

        gsap.to($sheet, {
            y: 0, 
            duration: 0.6,
            ease: "customEase",
        });

        Draggable.create($sheet.get(0), {
            trigger: $sheet.find(".drag-area").get(0),
            type: "y",
            bounds: {
                minY: ($sheet.height() * 1) + 50,
                maxY: -10
            },
            onDragEnd: function() {
                if (this.y > $sheet.height() * 0.1) {
                    gsap.to($sheet, {
                        y: ($sheet.height() * 1) + 50,
                        duration: 0.6,
                        ease: "customEase",
                    });

                    $overlay.removeClass("show");
                    $sheet.removeClass("show");
                    $('body').removeClass('overflow-hidden');
                } else {
                    gsap.to($sheet, {
                        y: 0,
                        duration: 0.6,
                        ease: "customEase" 
                    });
                }
            }
        });
    })

    $(document).on("click", "#overlay-bottom-sheet", function() {
        const $overlay = $(this);
        const $sheet = $(".bottom-sheet.show");

        gsap.to($sheet, {
            y: ($sheet.height() * 1) + 50,
            duration: 0.6,
            ease: "customEase",
        });

        

        $overlay.removeClass("show");
        $sheet.removeClass("show");
        $('body').removeClass('overflow-hidden');
    });
});

